module.exports = __webpack_public_path__ + "static/media/clock.d82b8ec6.svg";